import Link from "next/link";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import useReservations from "../../auth/Reservations";
import {
  CheckPaymentStatus,
  CreatePaymentLink,
  GetPaymentData,
  CheckValletPaymentStatus,
  AuthLogin,
  CreateHashData,
  GetPaymentStatus,
} from "../api";
import ReservationsLoading from "../Loaders/ReservationsLoading";
import { PaymentShema } from "../../validations/PaymentShema";
import { Formik, useFormikContext } from "formik";
import Input from "./Payment/Input";
import Contract from "../Reservation/Contract";
import axios from "axios";
import { toast } from "react-toastify";
import Right from "./Payment/Right";
import Title from "./Payment/Title";
import Installement from "./Payment/Installement";
import * as criteo from "../../scripts/criteo";
import { useTranslation } from "../../context/TranslationContext";
import CardIcon from "../../icons/CardIcon";
// import { b64_sha1 } from "../../helper/hex_sha1";
// import { on } from "form-data";
import useTiko from "../../hooks/useTiko";
import Countdown from "../CountDown";

const Payment = ({ ssr }) => {
  const {
    PayByCreditCardFormName,
    PayByCreditCardFormCardNumber,
    PayByCreditCardFormSubmit,
    dateMonth,
    dateYear,
    contract1,
    contract2,
    PaymentAuthRequired,
    reservations,
    login,
    paymentStatusChecking,
    closeWindowAfterPayment,
    clickToPay,
    installments369,
    bankRatesApply,
  } = useTranslation();
  const router = useRouter();

  const { data, error, loading, checkLogin, setLoading } = useReservations();
  const { TikoFormOnSubmit, TikoInstallment } = useTiko();
  const [paymentError, setPaymentError] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(false);

  const [cardNumberListen, setCardNumberListen] = useState("");
  const [installement, setInstallement] = useState([]);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [formData, setFormData] = useState(false);
  const [iframeModal, setIframeModal] = useState({
    open: false,
    src: "",
    onClose: null,
  });

  useEffect(() => {
    checkLogin();
    if (router.query?.conversationId) {
      setPaymentLoading(true);
      CheckValletPaymentStatus(router.query?.conversationId)
        .then((e) => {
          if (e.data.status) {
            criteo.payment(
              paymentDetails.email,
              paymentDetails.tarih,
              paymentDetails.tarih2,
              paymentDetails.yetiskin,
              paymentDetails.cocuk,
              paymentDetails.id,
              paymentDetails.evid,
              paymentDetails.tutar,
            );
            router.push(reservations.url);
          } else toast.error(e.data.response.bankMessage);
        })
        .finally(() => setPaymentLoading(false));
    }
  }, []);

  useEffect(() => {
    if (router?.query?.authKey || router.query.token) {
      AuthLogin(null, null, router.query.authKey, router.query.token)
        .then((response) => {
          if (response.data.error) {
            localStorage.removeItem("reservations_auth");
            toast.error(response.data.error);
          } else {
            localStorage.setItem("reservations_auth", response.data.token);
            checkLogin();
          }
        })
        .catch((error) => {
          toast.error(error.message);
        });
    } else {
      checkLogin();
    }
  }, []);

  useEffect(() => {
    if (data?.IsLogin) {
      GetPaymentData(data.IsLogin.Token, router.query["_"])
        .then((e) => {
          if (e.data.error) {
            setPaymentError(e.data.error);
          } else {
            setPaymentError(false);
            setPaymentDetails(e.data.data);
          }
        })
        .catch((e) => setPaymentError(e.message));
    }
  }, [data]);

  const DetectCardNumber = () => {
    const { values } = useFormikContext();
    useEffect(() => {
      if (values.cardNumber.length >= 7)
        setCardNumberListen(values.cardNumber.slice(0, 7).replace("-", ""));
      else setCardNumberListen("");
    }, [values]);
    return null;
  };

  useEffect(() => {
    if (cardNumberListen.length == 6 && paymentDetails) {
      if (paymentDetails.VirtualPosId == 5) {
        TikoInstallment({
          binNumber: cardNumberListen,
          price: paymentDetails.tutar,
        }).then((e) => {
          if (e.Result) {
            setInstallement(
              e.Result.map((e) => ({
                installmentNumber: e.Installment,
                installmentPrice: e.AmountPerMonth,
                totalPrice: e.Amount,
              })),
            );
          }
        });
      } else {
        axios
          .post("/api/InstallmentInfo", {
            binNumber: cardNumberListen,
            price: paymentDetails.tutar,
          })
          .then((e) => {
            if (e.data.status == "success") {
              setInstallement(e.data.installmentDetails[0].installmentPrices);
            } else {
              setInstallement([]);
            }
          });
      }
    } else setInstallement([]);
  }, [cardNumberListen, paymentDetails]);

  const FormOnSubmit = async (values, actions) => {
    if (paymentDetails.VirtualPosId == 3 && values.installement == 1) {
      paymentDetails.VirtualPosId = 4;
    }

    if (paymentDetails.VirtualPosId == 3)
      // Iyzico
      axios
        .post("/api/Payment?token=" + data.IsLogin.Token, {
          _: router.query["_"],
          ip: paymentDetails.ip,
          ...values,
        })
        .then((result) => {
          if (result.data.success) {
            setIframeModal({
              open: true,
              src: "/api/PaymentForm?_=" + router.query["_"],
              onClose: () => {
                CheckPaymentStatus(router.query._).then((e) => {
                  if (e.data.status == "success") {
                    criteo.payment(
                      paymentDetails.email,
                      paymentDetails.tarih,
                      paymentDetails.tarih2,
                      paymentDetails.yetiskin,
                      paymentDetails.cocuk,
                      paymentDetails.id,
                      paymentDetails.evid,
                      paymentDetails.tutar,
                    );
                    router.push(reservations.url);
                  }
                });
              },
            });
          } else {
            toast.error(result.data.error);
          }
        })
        .finally(() => {
          actions.setSubmitting(false);
        });

    if (paymentDetails.VirtualPosId == 4) {
      //HalkBank
      values.VirtualPosId = paymentDetails.VirtualPosId;
      values.price = paymentDetails.tutar;
      values.rez_no = paymentDetails.id;
      await CreateHashData(values).then((e) => {
        const data = e.data.data;
        const random = Math.floor(Math.random() * 1000000000);

        const formObj = {
          clientid: data.ClientId,
          amount: data.Amount,
          okurl: data.OkUrl,
          failUrl: data.FailUrl,
          TranType: data.Auth,
          callbackUrl: data.callback,
          currency: paymentDetails.PosCode,
          rnd: random,
          storetype: "3D_PAY",
          hashAlgorithm: "ver3",
          lang: "tr",
          BillToName: values.PaymentName,
          BillToCompany: values.PaymentName,
          SID: "id_" + random,
          sipBil: random,
          odeme_tipi: "Kredi Kartı",
          tampara: "",

          pan: values.cardNumber.replaceAll("-", ""),
          Ecom_Payment_Card_ExpDate_Month: values.month,
          Ecom_Payment_Card_ExpDate_Year: values.year,
          cv2: values.cvv,
          Instalment: data.Installment,
          isim: paymentDetails.musteri,
          email: paymentDetails.email,
          telefon: paymentDetails.telefon,
          mesaj: "",
          VirtualPosId: values.VirtualPosId,
          tutar: parseInt(data.Amount),
          gonder: "Ödemeyi Yap",
          ...values,
        };
        delete formObj.cvv;
        delete formObj.cardNumber;
        delete formObj.PaymentName;
        delete formObj.month;
        delete formObj.year;
        delete formObj.price;
        delete formObj.installement;
        delete formObj.kvkk;

        axios
          .post(process.env.NEXT_PUBLIC_API + "/CreateForm", formObj)
          .then((e) => {
            setIframeModal({
              open: true,
              src:
                process.env.NEXT_PUBLIC_API +
                "/CreateForm?rez_no=" +
                paymentDetails.id,
              onClose: () => {
                const toastId = toast.loading(paymentStatusChecking);
                GetPaymentStatus(formObj.sipBil + "-" + formObj.rez_no)
                  .then((e) => {
                    const r = JSON.parse(e.data.data.Response);
                    if (r?.ProcReturnCode == "00") {
                      criteo.payment(
                        paymentDetails.email,
                        paymentDetails.tarih,
                        paymentDetails.tarih2,
                        paymentDetails.yetiskin,
                        paymentDetails.cocuk,
                        paymentDetails.id,
                        paymentDetails.evid,
                        paymentDetails.tutar,
                      );
                      router.push(reservations.url);
                    }
                    if (r.mdErrorMsg && r?.ProcReturnCode !== "00") {
                      toast.error(r.mdErrorMsg + (r?.ErrMsg ? r?.ErrMsg : ""));
                    }
                  })
                  .finally(() => {
                    toast.dismiss(toastId);
                  });
              },
            });
          });
      });

      actions.setSubmitting(false);
    } else if (paymentDetails.VirtualPosId == 5) {
      //Tiko
      await TikoFormOnSubmit(values, paymentDetails, router.query["_"]);
      actions.setSubmitting(false);
    }
  };
  const HandleClick = async () => {
    setPaymentLoading(true);
    await CreatePaymentLink(data.IsLogin.Token, router.query["_"])
      .then((result) => {
        const { data } = result;
        if (data.Response.status == "success") {
          router.replace(data.Response.payment_page_url);
          CheckValletPaymentStatus(data.Response.conversationId).then((e) => {
            if (e?.data?.status == true) {
              criteo.payment(
                paymentDetails.email,
                paymentDetails.tarih,
                paymentDetails.tarih2,
                paymentDetails.yetiskin,
                paymentDetails.cocuk,
                paymentDetails.id,
                paymentDetails.evid,
                paymentDetails.tutar,
              );
              router.push(reservations.url);
            }
          });
        }
        if (data.error) {
          toast.error(data.error);
        }
      })
      .finally(() => setPaymentLoading(false));
  };
  const closeIframeModal = () => {
    const onClose = iframeModal.onClose;
    setIframeModal({ open: false, src: "", onClose: null });
    if (onClose) onClose();
  };

  return (
    <>
      {iframeModal.open && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center"
          style={{ backgroundColor: "rgba(0,0,0,0.7)" }}
          onClick={(e) => {
            if (e.target === e.currentTarget) closeIframeModal();
          }}
        >
          <div
            className="relative bg-white rounded-xl overflow-hidden flex flex-col"
            style={{ width: "500px", height: "90vh", maxWidth: "95vw" }}
          >
            <div className="flex items-center justify-between px-4 py-3 shrink-0 border-b border-gray-100">
              <span className="text-sm text-gray-500">
                {closeWindowAfterPayment}
              </span>
              <button
                onClick={closeIframeModal}
                className="ml-4 shrink-0 w-9 h-9 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600 hover:text-gray-900 text-xl font-bold leading-none transition-colors"
              >
                ×
              </button>
            </div>
            <iframe
              src={iframeModal.src}
              className="w-full flex-1 border-0"
              allow="fullscreen"
            />
          </div>
        </div>
      )}
      <div className="lg:h-[calc(100vh-96px)] pb-16 lg:pb-0 overflow-hidden bg-brand-white bg-opacity-50 flex items-center justify-center">
        <div className="container flex items-center justify-center ">
          <div className="lg:w-[64.375rem] w-full min-h-[500px] bg-white rounded-[1.875rem] lg:py-[3.688rem] sm:py-8 py-4 lg:px-[3.125rem] sm:px-8 px-4 lg:my-0 my-4">
            {loading ? (
              <ReservationsLoading />
            ) : data &&
              data.IsLogin != false &&
              !paymentError &&
              paymentDetails ? (
              <>
                <Countdown
                  expiredOn={paymentDetails?.saat}
                  currentDate={paymentDetails?.CurrentDate}
                  className="!rounded-lg"
                />
                <div className="flex lg:gap-x-[3.313rem] gap-y-7 flex-col lg:flex-row">
                  {(paymentDetails.VirtualPosId == "1" ||
                    paymentDetails.VirtualPosId == "2") && (
                    <div className="w-full flex flex-col content-center justify-center min-h-[500px]">
                      <div
                        className="flex flex-col items-center w-full border py-5 cursor-pointer"
                        onClick={HandleClick}
                      >
                        {paymentLoading ? (
                          <ReservationsLoading />
                        ) : (
                          <>
                            <CardIcon className="w-10 h-10" />
                            <span className="font-bold text-25 text-primary">
                              {clickToPay}
                            </span>
                            {paymentDetails.VirtualPosId == "2" && (
                              <span>
                                {installments369}
                              </span>
                            )}
                            <span>
                              {bankRatesApply}
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  )}
                  {(paymentDetails.VirtualPosId == "3" ||
                    paymentDetails.VirtualPosId == "5" ||
                    paymentDetails.VirtualPosId == "4") && (
                    <>
                      <div className="lg:w-1/2 order-2 lg:order-1">
                        <Title paymentDetails={paymentDetails} />
                        <Formik
                          initialValues={{
                            PaymentName: "",
                            cardNumber: "",
                            month: "",
                            year: "",
                            cvv: "",
                            sozlesme: false,
                            kvkk: false,
                            installement: 1,
                          }}
                          validationSchema={PaymentShema}
                          onSubmit={FormOnSubmit}
                        >
                          {(props) => (
                            <form onSubmit={props.handleSubmit}>
                              <div className="relative z-0 mb-6 w-full group">
                                <Input
                                  name="PaymentName"
                                  placeholder=" "
                                  label={PayByCreditCardFormName}
                                />
                              </div>
                              <div className="relative z-0 mb-6 w-full group">
                                <Input
                                  name="cardNumber"
                                  placeholder=""
                                  label={PayByCreditCardFormCardNumber}
                                  mask="____-____-____-____"
                                  replacement={{ _: /\d/ }}
                                />
                                <Installement
                                  installement={installement}
                                  handleChange={props.handleChange}
                                  paymentDetails={paymentDetails}
                                />
                              </div>
                              <div className="grid grid-cols-3 gap-x-4">
                                <div className="relative z-0 mb-6 w-full group">
                                  <Input
                                    name="month"
                                    placeholder="- -"
                                    label={dateMonth}
                                    mask="__"
                                    replacement={{ _: /\d/ }}
                                  />
                                </div>
                                <div className="relative z-0 mb-6 w-full group">
                                  <Input
                                    name="year"
                                    placeholder="- -"
                                    label={dateYear}
                                    mask="__"
                                    replacement={{ _: /\d/ }}
                                  />
                                </div>
                                <div className="relative z-0 mb-6 w-full group">
                                  <Input
                                    name="cvv"
                                    placeholder="- - -"
                                    label={"CVC"}
                                    mask="___"
                                    replacement={{ _: /\d/ }}
                                  />
                                </div>
                              </div>
                              <div className="flex flex-col sm:flex-row items-center justify-center sm:justify-between flex-wrap ">
                                <div className="flex flex-col gap-2">
                                  <Contract
                                    name="sozlesme"
                                    text={contract1}
                                    content={ssr.result.sozlesme.icerik}
                                  ></Contract>
                                  <Contract
                                    name="kvkk"
                                    text={contract2}
                                    content={ssr.result.kvkk.icerik}
                                  ></Contract>
                                </div>
                                <button
                                  type="submit"
                                  disabled={
                                    props.isSubmitting ||
                                    !props.isValid ||
                                    !props.dirty
                                  }
                                  className="mt-3 text-white md:px-[2.75rem] px-8 md:py-[1.188rem] py-3 duration-200 bg-product-type-color hover:bg-opacity-80 focus:ring-4 focus:outline-none  font-medium rounded-lg text-sm  text-center disabled:opacity-60 disabled:cursor-not-allowed"
                                >
                                  {PayByCreditCardFormSubmit}
                                </button>
                              </div>
                              {paymentDetails.VirtualPosId == 3 ||
                              paymentDetails.VirtualPosId == 5 ? (
                                <DetectCardNumber />
                              ) : null}
                            </form>
                          )}
                        </Formik>
                      </div>
                      <Right paymentDetails={paymentDetails} />
                    </>
                  )}
                </div>
              </>
            ) : paymentError ? (
              <section className="flex items-center h-full sm:p-16">
                <div className="container flex flex-col items-center justify-center px-5 mx-auto my-8 space-y-3 text-center sm:max-w-md">
                  <p className="">{paymentError}</p>
                </div>
              </section>
            ) : (
              <section className="flex items-center h-full sm:p-16">
                <div className="container flex flex-col items-center justify-center px-5 mx-auto my-8 space-y-3 text-center sm:max-w-md">
                  <p className="">{PaymentAuthRequired}</p>
                  <Link href={reservations.url}>
                    <a
                      rel="noopener noreferrer"
                      className="px-4 py-1 rounded bg-brand-color-primary text-white text-sm"
                    >
                      {login}
                    </a>
                  </Link>
                </div>
              </section>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Payment;
